import React from 'react';
import TopFooter from './TopFooter/TopFooter';
import BottemFooter from './BottemFooter/BottemFooter';
import './Footer.css';

function Footer() {
  return (
    <div className="footer-container">
      <div className="footer-background"></div>
      <div className="footer-content">
        <TopFooter />
        <BottemFooter />
      </div>
    </div>
  );
}

export default Footer;
